import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { AssetModel } from '@app/core/models/assets/asset.model';
import { AssetService } from '@app/core/services/asset.service';
import { AdministrationBase } from '@app/features/administration/administration-base';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss'],
})
export class AssetListComponent
  extends AdministrationBase<AssetModel>
  implements OnInit, OnDestroy
{
  constructor(
    route: ActivatedRoute,
    router: Router,
    dialog: MatDialog,
    authenticationInfoService: AuthenticationInfoService,
    public assetService: AssetService
  ) {
    super(dialog, router, route, authenticationInfoService);
    this.title = 'REFERENCES';
    this.subtitle = 'reference';
  }

  ngOnInit(): void {}

  protected activateItem(id: any): Observable<any> {
    return this.assetService.activateAsset(id);
  }

  protected deactivateItem(id: any): Observable<any> {
    return this.assetService.deactivateAsset(id);
  }

  protected getDataItems(): Observable<AssetModel[]> {
    return this.assetService.getAssetsByType();
  }

  importHandler = (files: File[]): Observable<ImportReportModel[]> => {
    return this.assetService.importAssets(files);
  };

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  onClearFilters = (): void => {
    this.onFiltersCleared.next();
  };

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }
}
